module.exports = __webpack_public_path__ + "static/media/cat.6da6dc4f.jpg";